module.exports = __webpack_public_path__ + "static/img/client16_img.5338466.png";